import React from 'react';
import styled from 'styled-components';
import { Props as JustificationContainerProps } from '~/components/atom/JustificationContainer';
import Small from './components/Small';
import Large from './components/Large';
import useMeasure from '~/hooks/useMeasure';
import type { IconType } from '~/components/atom/Icon';
import type { InteractiveAppearance } from '~/styles/constants';
import type { ThemeColor } from '~/theme/System/tokens/colorPalette';

export type CTAIcon = {
  name?: IconType;
  background?: ThemeColor;
};

export type Props = {
  header?: React.ReactNode;
  description?: string;

  /** Icon on the left */
  icon?: CTAIcon;

  /** Button on the right */
  button?: {
    dataTestId?: string;
    label: string;
    appearance?: InteractiveAppearance;
    icon?: IconType;
    onClick: () => void;
    loading?: boolean;
    disabled?: boolean;
  };

  linkButton?: {
    label: string;
    appearance: InteractiveAppearance;
    icon: IconType;
    to: string;
  };

  /** Margin of the container */
  margin?: JustificationContainerProps['margin'];

  /** Padding of the container */
  padding?: JustificationContainerProps['padding'];

  /** Aligns content at the top or the center */
  align?: 'start' | 'center';

  width?: string;

  /** If not passed, close button will not be rendered */
  onClose?: () => void;
};

const CallToActionBlock: React.FCC<Props> = ({ ...rest }) => {
  const { ref, bounds } = useMeasure();

  const isSmall = bounds.width < 500 && bounds.width !== 0;

  return (
    <Container ref={ref}>
      {isSmall ? <Small {...rest} /> : <Large {...rest} />}
    </Container>
  );
};

export const Container = styled.div`
  width: 100%;
`;
export default CallToActionBlock;
